import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cashImage from '../../../../../images/kushki/cash.png';
import transferImage from '../../../../../images/kushki/transfer.png';
import payPal from '../../../../../images/kushki/payPal.png';
import cardImage from '../../../../../images/kushki/card.png';
import { AVAILABLE_PAYMENT_METHODS, PAYMENT_METHOD_KEYS } from '../../../payment.constants';
import Spinner from '../../../../../ui/spinner/spinner';
import { changeState, resetPaymentErrors } from '../../../reducers';
import { getActivePaymentMethodKey } from '../../../payment.helpers';
import './kushki-buttons.scss';

type KushkiButtonsProps = {};

const KushkiButtons: FC<KushkiButtonsProps> = () => {
    const dispatch = useDispatch();
    const { paymentOptionsData, paymentOptionsAvailability, activePaymentOption } = useSelector((state: RootState) => state.payment);

    const handleButtonClicked = (method: PAYMENT_METHOD_KEYS) => {
        dispatch(changeState({ activePaymentOption: AVAILABLE_PAYMENT_METHODS[method] }));
        dispatch(resetPaymentErrors());
    };

    const isMethodAvailable = (method: PAYMENT_METHOD_KEYS) => {
        return paymentOptionsData?.allowedPaymentMethods.includes(method);
    }

    const isMethodActive = (method: PAYMENT_METHOD_KEYS) => {
        return getActivePaymentMethodKey(activePaymentOption?.id ?? '') === method;
    }

    const cardButton = () => {
        if (isMethodAvailable(PAYMENT_METHOD_KEYS.KUSHKI_CARD)) {
            return (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.KUSHKI_CARD) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.KUSHKI_CARD}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.KUSHKI_CARD)}
                >
                    <div>
                        <img alt='card' src={cardImage} />
                        <p className={isMethodActive(PAYMENT_METHOD_KEYS.KUSHKI_CARD) ? 'active' : ''}>Tarjeta de Crédito/Débito</p>
                    </div>
                </button>
            );
        }

        if (isMethodAvailable(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD)) {
            return (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD)}
                >
                    <div>
                        <img alt='card' src={cardImage} />
                        <p className={isMethodActive(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD) ? 'active' : ''}>
                            Tarjeta de Crédito/Débito
                        </p>
                    </div>
                </button>
            );
        }
    };

    return (
        <div className='kushki-buttons'>
            {isMethodAvailable(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT) && (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT)}
                >
                    <div>
                        <img alt='transfer' src={payPal} style={{ width: 100 }} />
                    </div>
                </button>
            )}

            {cardButton()}

            {(paymentOptionsAvailability?.get(PAYMENT_METHOD_KEYS.APPLE_PAY)) === null && (
                <button>
                    <div>
                        <Spinner />
                    </div>
                </button>
            )}
            {paymentOptionsAvailability?.get(PAYMENT_METHOD_KEYS.APPLE_PAY) && (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.APPLE_PAY) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.APPLE_PAY}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.APPLE_PAY)}
                >
                    <div>
                        <img src={AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.APPLE_PAY].img} alt='' />
                        <p>{AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.APPLE_PAY].title}</p>
                    </div>
                </button>
            )}

            {(paymentOptionsAvailability?.get(PAYMENT_METHOD_KEYS.GOOGLE_PAY) === null) && (
                <button>
                    <div>
                        <Spinner />
                    </div>
                </button>
            )}
            {paymentOptionsAvailability?.get(PAYMENT_METHOD_KEYS.GOOGLE_PAY) && (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.GOOGLE_PAY) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.GOOGLE_PAY}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.GOOGLE_PAY)}
                >
                    <div>
                        <img src={AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.GOOGLE_PAY].img} alt='' />
                        <p>{AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.GOOGLE_PAY].title}</p>
                    </div>
                </button>
            )}

            {isMethodAvailable(PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER) && (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER)}
                >
                    <div>
                        <img alt='transfer' src={transferImage} />
                        <p className={isMethodActive(PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER) ? 'active' : ''}>Transferencia Bancaria</p>
                    </div>
                </button>
            )}

            {isMethodAvailable(PAYMENT_METHOD_KEYS.KUSHKI_CASH) && (
                <button
                    className={isMethodActive(PAYMENT_METHOD_KEYS.KUSHKI_CASH) ? 'active' : ''}
                    name={PAYMENT_METHOD_KEYS.KUSHKI_CASH}
                    onClick={() => handleButtonClicked(PAYMENT_METHOD_KEYS.KUSHKI_CASH)}
                >
                    <div>
                        <img alt='cash' className='img-cash' src={cashImage} />
                        <p className={isMethodActive(PAYMENT_METHOD_KEYS.KUSHKI_CASH) ? 'active' : ''}>Pago en efectivo</p>
                    </div>
                </button>
            )}
        </div>
    );
};

export default KushkiButtons;
